import {IDefaultQueryParams} from "@/core/constant/defaultQueryParams";
import {CoreLanguage} from "@/core/enums";

export enum CourseStatus {
    INACTIVE = 0,
    ACTIVE = 1,
}

export enum PackageStatus {
    INACTIVE = 0,
    ACTIVE = 1,
}

export const getPackageStatusName = (status: PackageStatus): string => {
    switch (status) {
        case PackageStatus.ACTIVE:
            return "active";
        case PackageStatus.INACTIVE:
            return "inactive";
        default:
            return "Unknown";
    }
}

export interface GetCoursesRequstDto {
    title: string;
    gradeId: string;
    subjectId: string;
    status: CourseStatus;
    pageNumber: number;
    pageSize: number;
}

export interface Course {
    id: string;
    title: string;
    description: string;
    gradeId: string;
    gradeName: string;
    photo: string;
    subjectId: string;
    subjectName: string;
    language: CoreLanguage;
    status: CourseStatus;
}
